import VerticalCenter from "../common/components/VerticalCenter";
import { RootState } from "../app/Store";
import { useStore } from "react-redux";
import { selectRecievedWish } from "../features/listenerProfile/select";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const ReceivedWord = () => {
  const state = useStore().getState() as RootState;
  const { t } = useTranslation();
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const wish = selectRecievedWish(state);

  useEffect(() => {
    // Set a timeout to add the fade class after 10 seconds
    setTimeout(() => {
      const element = document.querySelector(".received-word-text");
      if (element) {
        element.classList.add("fade");
      }
    }, 7000); // 7000 milliseconds = 7 seconds
  });

  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  // Show black screen while video is loading
  if (!isVideoLoaded) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          zIndex: 9999,
        }}
      >
        <video
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={handleVideoLoad}
          style={{ display: "none" }}
        >
          <source
            src="assets/animations/returning-word-of-encouragement.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    );
  }

  return (
    <VerticalCenter>
      <div className="star-container">
        <video autoPlay muted loop playsInline className="star-video">
          <source
            src="assets/animations/returning-word-of-encouragement.mp4"
            type="video/mp4"
          />
        </video>
        <div className="star-content">
          <Center>
            <div
              className="circle enter-animation"
              aria-label="A monochromatic flower icon with wispy fluffy
                petals. Superimposed on top is the wish that you just wrote!."
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="flower-filter-input">
                <p style={{ color: "black" }}>{wish}</p>
              </div>
            </div>
          </Center>
          <Center>
            <Padding>
              <h2
                style={{
                  color: "#ededed",
                }}
              >
                {t("Someone here sent this to you.")}
              </h2>
            </Padding>
          </Center>
        </div>
      </div>
    </VerticalCenter>
  );
};

export default ReceivedWord;
